import React from 'react';

const ColorBar = ({ title }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '35px', height: '100%' }}>
            <span style={{ fontSize: '9px', fontWeight: 'bold', color: '#ef4444' }}>+3</span>
            <div style={{
                width: '8px',
                height: '70px',
                background: 'linear-gradient(to bottom, #ef4444, #f59e0b, #10b981, #3b82f6, #1e3a8a)',
                borderRadius: '2px',
                margin: '4px 0'
            }}></div>
            <span style={{ fontSize: '9px', fontWeight: 'bold', color: '#1e3a8a' }}>-3</span>
            {title && <span style={{ fontSize: '8px', transform: 'rotate(90deg)', whiteSpace: 'nowrap', marginTop: '15px', color: '#64748b', fontWeight: '600' }}>{title}</span>}
        </div>
    );
};

export default ColorBar;